import { render } from "./thermalPrint.vue?vue&type=template&id=37e354bb&scoped=true"
import script from "./thermalPrint.vue?vue&type=script&lang=js"
export * from "./thermalPrint.vue?vue&type=script&lang=js"

import "./thermalPrint.vue?vue&type=style&index=0&id=37e354bb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37e354bb"]])

export default __exports__